import { IScriptingContainer } from '@aspendental/needs-based-questions/dist/Questionnaire/Questionnaire.types';
import { FormLabel, Typography } from '@mui/material';

export default function ScriptingContainer({
	questionText,
	explanationText,
	dataTestPostfix,
	required,
	value,
	hasError,
}: IScriptingContainer) {
	return (
		<section data-test-id={`section_scripting_container_${dataTestPostfix}`}>
			<div>
				{questionText && (
					<FormLabel
						required={required}
						id={dataTestPostfix}
						sx={{ color: hasError && value?.length === 0 ? 'error.dark' : 'text.secondary' }}
					>
						<Typography
							data-test-id={`scripting_${dataTestPostfix}`}
							variant="bodyLargeSemiBold"
							sx={{ color: hasError && value?.length === 0 ? 'error.dark' : 'text.primary' }}
						>
							{questionText}
						</Typography>
					</FormLabel>
				)}

				{explanationText && (
					<Typography data-test-id={`explanation_${dataTestPostfix}`}>{explanationText}</Typography>
				)}
			</div>
		</section>
	);
}
